import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteAutojoinDomainMutation($input: DeleteAutojoinDomainInput!) {
		deleteAutojoinDomain(input: $input) {
			deletedAutojoinDomainId
		}
	}
`;

function getConfigs(companyId) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: companyId,
			connectionKeys: [
				{
					key: 'Company_autojoinDomains',
				},
			],
			pathToConnection: ['company', 'autojoinDomains'],
			deletedIDFieldName: 'deletedAutojoinDomainId',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Autojoin Domain Deleted');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), id: input.id}},
		configs: getConfigs(input.companyId),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
